import React, {
  useEffect, useRef, useLayoutEffect, useState
} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_omanLow from '@amcharts/amcharts4-geodata/omanLow';
import * as am4charts from '@amcharts/amcharts4/charts';
// import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_COLORS, CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function MapPieChart(props) {
  const [viewData, setViewData] = useState([]);
  const { outletSale } = props;
  useEffect(() => {
    if (outletSale) {
      if (outletSale.length === 0) {
        // const viewDetail = [];
        // const details = {
        //   category: "Not Available",
        //   first: 0,
        //   second: 0
        // };
        // viewDetail.push(details);
        // setViewData(viewDetail);
      } else {
        const clinic = outletSale;
        const viewDetail = [];
        for (let index = 0; index < clinic.length; index++) {
          if((index + 1) > CHART_MAX_VALUES) {
            break;
          }
          const details = {
            title: clinic[0].OutletName,
            latitude: clinic[0].Latitude,
            longitude: clinic[0].Longitude,
            width: 100,
            height: 100,
            pieData: [{
              category: 'HBB',
              value: clinic[0].HBB
            }, {
              category: 'Baqati',
              value: clinic[0].Baqati
            }, {
              category: 'Hayyak',
              value: clinic[0].Hayyak
            }, {
              category: 'Upgrade',
              value: clinic[0].Upgrade
            }]
          };
          viewDetail.push(details);
        }
        setViewData(viewDetail);
      }
    }
  }, [outletSale]);
  useLayoutEffect(() => {
    const chart = am4core.create('chartdiv27', am4maps.MapChart);
    chart.geodata = am4geodata_omanLow;

    // Set projection
    // chart.projection = new am4maps.projections.Miller();

    // Create map polygon series
    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    // polygonSeries.exclude = ["antarctica"];
    polygonSeries.useGeodata = true;

    // Create an image series that will hold pie charts
    const pieSeries = chart.series.push(new am4maps.MapImageSeries());
    const pieTemplate = pieSeries.mapImages.template;
    pieTemplate.propertyFields.latitude = 'latitude';
    pieTemplate.propertyFields.longitude = 'longitude';

    const pieChartTemplate = pieTemplate.createChild(am4charts.PieChart);
    pieChartTemplate.adapter.add('data', (data, target) => {
      if (target.dataItem) {
        return target.dataItem.dataContext.pieData;
      }

      return [];
    });
    pieChartTemplate.propertyFields.width = 'width';
    pieChartTemplate.propertyFields.height = 'height';
    pieChartTemplate.horizontalCenter = 'middle';
    pieChartTemplate.verticalCenter = 'middle';

    const pieTitle = pieChartTemplate.titles.create();
    pieTitle.text = '{title}';

    const pieSeriesTemplate = pieChartTemplate.series.push(new am4charts.PieSeries());
    pieSeriesTemplate.dataFields.category = 'category';
    pieSeriesTemplate.dataFields.value = 'value';
    pieSeriesTemplate.labels.template.disabled = true;
    pieSeriesTemplate.ticks.template.disabled = true;

    pieSeries.data = viewData
    // pieSeries.data = [
    //   {
    //     title: 'Outlet 1',
    //     latitude: 23.590754190978085,
    //     longitude: 58.414862210180104,
    //     width: 100,
    //     height: 100,
    //     pieData: [{
    //       category: 'HBB',
    //       value: 1200
    //     }, {
    //       category: 'Baqati',
    //       value: 500
    //     }, {
    //       category: 'Hayyak',
    //       value: 765
    //     }, {
    //       category: 'Upgrade',
    //       value: 260
    //     }]
    //   },
    //   {
    //     title: 'Outlet 2',
    //     latitude: 18.242874605507804,
    //     longitude: 54.100197358943966,
    //     width: 100,
    //     height: 100,
    //     pieData: [{
    //       category: 'HBB',
    //       value: 1200
    //     }, {
    //       category: 'Baqati',
    //       value: 500
    //     }, {
    //       category: 'Hayyak',
    //       value: 765
    //     }, {
    //       category: 'Upgrade',
    //       value: 260
    //     }]
    //   },
      

    // ];

    // Modify chart's colors
    chart.colors.list = CHART_COLORS;

    chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return (
    <div id="chartdiv27" style={{ width: '100%', height: '500px', direction: "ltr" }} />
  );
}
